import { IShellEvent } from './IShellEvent';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { LogoutService } from '../../authentication/logout.service';

@Injectable({ providedIn: 'root' })
export class ShellTokenExpiredEvent implements IShellEvent {
	constructor(
		private logoutService: LogoutService,
		private router: Router
	) {}

	get eventName(): string {
		return ShellCommunicationEvents.TokenExpired;
	}

	handleCustomEvent(event): void {
		this.handle(event.detail.sessionId);
	}

	handlePostMessage(event): void {
		this.handle(event.payload.sessionId);
	}

	private handle(sessionId) {
		this.logoutService.logout(String(sessionId), { returnUrl: this.router.url }).pipe(take(1)).subscribe();
	}
}
